import { render, staticRenderFns } from "./driverDetail.vue?vue&type=template&id=d1620670&scoped=true&"
import script from "./driverDetail.vue?vue&type=script&lang=js&"
export * from "./driverDetail.vue?vue&type=script&lang=js&"
import style0 from "./driverDetail.vue?vue&type=style&index=0&id=d1620670&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1620670",
  null
  
)

export default component.exports